import normalizeProjectId from '@/lib/normalizeProjectId.js';
import getThreadId from '@/lib/threads/getThreadId.js';
import getThreadParentId from '@/lib/threads/getThreadParentId.js';
import getThreadProjectId from '@/lib/threads/getThreadProjectId.js';

const HOME_PROJECT_ID = 'project-home';

const mergeThreadProjectMetadata = ({ threads, projectMetaById, existingThreadsById, activeProjectId }) => {
  const resolveHomeProjectId = () => {
    if (projectMetaById?.[HOME_PROJECT_ID]) {
      return HOME_PROJECT_ID;
    }

    const normalizedActiveProjectId = normalizeProjectId(activeProjectId);
    const activeProject = normalizedActiveProjectId ? projectMetaById?.[normalizedActiveProjectId] : null;

    if (activeProject && Boolean(activeProject?.isHome ?? activeProject?.is_home)) {
      return normalizedActiveProjectId;
    }

    for (const project of Object.values(projectMetaById || {})) {
      const projectId = normalizeProjectId(project?.id || project?.projectId);

      if (!projectId) {
        continue;
      }

      if (projectId === HOME_PROJECT_ID || Boolean(project?.isHome ?? project?.is_home)) {
        return projectId;
      }
    }

    return null;
  };

  const homeProjectId = resolveHomeProjectId();

  return (threads || []).map((thread) => {
    const threadId = getThreadId(thread);
    const payloadProjectId = getThreadProjectId(thread);
    const existingProjectId = normalizeProjectId(existingThreadsById?.[threadId]?.projectId);
    const projectId = payloadProjectId || existingProjectId || homeProjectId || null;
    const projectMeta = projectId ? projectMetaById?.[projectId] || null : null;
    const parentThreadId = getThreadParentId(thread) || getThreadParentId(existingThreadsById?.[threadId] || {}) || null;

    if (!projectId) {
      return {
        ...thread,
        ...(parentThreadId ? { parentThreadId } : {})
      };
    }

    return {
      ...thread,
      ...(parentThreadId ? { parentThreadId } : {}),
      projectId,
      project: projectMeta
        ? {
            ...(thread?.project || {}),
            ...projectMeta,
            id: projectId
          }
        : thread?.project || { id: projectId }
    };
  });
};

export default mergeThreadProjectMetadata;
